module.exports = __webpack_public_path__ + "assets/img/35f8b4587889b1769b9cdd16295c9e50.png";